import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

export const iconButtonDefaultStyles = {
  tiny: {
    borderRadius: "3px",
    iconSize: "10px",
    size: "16px",
    padding: "3px",
  },
  smallest: {
    borderRadius: "4px",
    iconSize: "12px",
    size: "20px",
    padding: "4px",
  },
  smaller: {
    borderRadius: "8px",
    iconSize: "20px",
    size: "32px",
    padding: "6px",
  },
  larger: {
    borderRadius: "10px",
    iconSize: "48px",
    size: "64px",
    padding: "8px",
  },
};

export const useIconButtonStyles = makeStyles()({
  tiny: {
    borderRadius: iconButtonDefaultStyles.tiny.borderRadius,
    height: iconButtonDefaultStyles.tiny.size,
    padding: iconButtonDefaultStyles.tiny.padding,
    width: iconButtonDefaultStyles.tiny.size,
    "&:hover": {
      borderRadius: iconButtonDefaultStyles.tiny.borderRadius,
      height: iconButtonDefaultStyles.tiny.size,
      width: iconButtonDefaultStyles.tiny.size,
    },
  },
  smallest: {
    borderRadius: iconButtonDefaultStyles.smallest.borderRadius,
    height: iconButtonDefaultStyles.smallest.size,
    width: iconButtonDefaultStyles.smallest.size,
    padding: iconButtonDefaultStyles.smallest.padding,
    "&:hover": {
      borderRadius: iconButtonDefaultStyles.smallest.borderRadius,
      height: iconButtonDefaultStyles.smallest.size,
      width: iconButtonDefaultStyles.smallest.size,
    },
  },
  smaller: {
    borderRadius: iconButtonDefaultStyles.smaller.borderRadius,
    height: iconButtonDefaultStyles.smaller.size,
    padding: iconButtonDefaultStyles.smaller.padding,
    width: iconButtonDefaultStyles.smaller.size,
    "&:hover": {
      borderRadius: iconButtonDefaultStyles.smaller.borderRadius,
      height: iconButtonDefaultStyles.smaller.size,
      width: iconButtonDefaultStyles.smaller.size,
    },
  },
  larger: {
    borderRadius: iconButtonDefaultStyles.larger.borderRadius,
    height: iconButtonDefaultStyles.larger.size,
    width: iconButtonDefaultStyles.larger.size,
    padding: iconButtonDefaultStyles.larger.padding,
    "&:hover": {
      borderRadius: iconButtonDefaultStyles.larger.borderRadius,
      height: iconButtonDefaultStyles.larger.size,
      width: iconButtonDefaultStyles.larger.size,
    },
  },
});

export const useContainedIconButtonStyles = makeStyles()({
  primary: {
    backgroundColor: colors.mapped.surface.default,
    color: colors.mapped.surface.systemWhite,
    "&:hover": {
      backgroundColor: colors.mapped.surface.hover,
    },
    "&:active": {
      backgroundColor: colors.mapped.surface.active,
    },
  },
  error: {
    backgroundColor: colors.mapped.surface.errorDefault,
    color: colors.mapped.surface.systemWhite,
    "&:hover": {
      backgroundColor: colors.mapped.surface.errorHover,
    },
    "&:active": {
      backgroundColor: colors.mapped.surface.errorActive,
    },
  },
  warning: {
    backgroundColor: colors.mapped.surface.warningDefault,
    color: colors.mapped.surface.systemWhite,
    "&:hover": {
      backgroundColor: colors.mapped.surface.warningHover,
    },
    "&:active": {
      backgroundColor: colors.mapped.surface.warningActive,
    },
  },
  neutral: {
    backgroundColor: colors.mapped.surface.neutralDefault,
    color: colors.mapped.surface.systemWhite,
    "&:hover": {
      backgroundColor: colors.mapped.surface.neutralHover,
    },
    "&:active": {
      backgroundColor: colors.mapped.surface.neutralActive,
    },
  },
});

export const useOutlinedBorderWidthStyles = makeStyles()({
  tiny: {
    borderWidth: "1px",
    borderStyle: "solid",
  },
  smallest: {
    borderWidth: "1.5px",
    borderStyle: "solid",
  },
  smaller: {
    borderWidth: "1.5px",
    borderStyle: "solid",
  },
  small: {
    borderWidth: "1.5px",
    borderStyle: "solid",
  },
  default: {
    borderWidth: "1.5px",
    borderStyle: "solid",
  },
  large: {
    borderWidth: "2px",
    borderStyle: "solid",
  },
  larger: {
    borderWidth: "2px",
    borderStyle: "solid",
  },
});

export const useOutlinedIconButtonStyles = makeStyles()({
  primary: {
    borderColor: colors.mapped.surface.default,
    color: colors.mapped.surface.default,
    "&:hover": {
      borderColor: colors.mapped.surface.hover,
      color: colors.mapped.surface.hover,
    },
    "&:active": {
      borderColor: colors.mapped.surface.active,
      color: colors.mapped.surface.active,
    },
  },
  error: {
    borderColor: colors.mapped.surface.errorDefault,
    color: colors.mapped.surface.errorDefault,
    "&:hover": {
      borderColor: colors.mapped.surface.errorHover,
      color: colors.mapped.surface.errorHover,
    },
    "&:active": {
      borderColor: colors.mapped.surface.errorActive,
      color: colors.mapped.surface.errorActive,
    },
  },
  warning: {
    borderColor: colors.mapped.surface.warningDefault,
    color: colors.mapped.surface.warningDefault,
    "&:hover": {
      borderColor: colors.mapped.surface.warningHover,
      color: colors.mapped.surface.warningHover,
    },
    "&:active": {
      borderColor: colors.mapped.surface.warningActive,
      color: colors.mapped.surface.warningActive,
    },
  },
  neutral: {
    borderColor: colors.mapped.surface.neutralDefault,
    color: colors.mapped.surface.neutralDefault,
    "&:hover": {
      borderColor: colors.mapped.surface.neutralHover,
      color: colors.mapped.surface.neutralHover,
    },
    "&:active": {
      borderColor: colors.mapped.surface.neutralActive,
      color: colors.mapped.surface.neutralActive,
    },
  },
});
